if (!customElements.get('lisa-sock-picker')) {
  customElements.define('lisa-sock-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-sock-variants]');
      const native = this.querySelector('[data-sock-native]');
      const selects = [...native?.querySelectorAll('select') || []];
      if (!data || !selects.length) return;
      const variants = JSON.parse(data.textContent);
      const labels = JSON.parse(document.getElementById('LisaSockStrings').textContent);
      const packIndex = selects.length - 1;
      const isBulk = v => (v.sku || '').endsWith('-BULK144');
      const selected = () => variants.find(v => selects.every((s,i) => v.options[i] === s.value));
      const money = p => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(p / 100);
      const make = (tag, cls, text) => {const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;};
      const key = selects[0].id || `sock-${Math.random().toString(36).slice(2)}`;
      const packs = make('fieldset','lisa-beanie__packs');
      packs.append(make('legend','form__label',labels.buy));
      const controls = [];
      for (const bulk of [false,true]) {
        const label=make('label','lisa-beanie__pack'), input=make('input'), price=make('strong','lisa-beanie__pack-price'), detail=make('small','lisa-beanie__pack-detail');
        input.type='radio';input.name=key+'-pack';input.value=bulk?'bulk':'dozen';
        label.append(input,make('span','lisa-beanie__pack-title',bulk?labels.bulk:labels.dozen),price,detail);
        packs.append(label);controls.push({bulk,input,price,detail});
      }
      const groups=[];
      for (let i=0;i<packIndex;i++) {
        const values=[...new Set(variants.map(v=>v.options[i]))];
        if (values.length<2) continue;
        const group=make('fieldset','lisa-beanie__colors'), legend=make('legend','form__label');
        const nativeLabel=selects[i].closest('label')?.querySelector('span')?.textContent || selects[i].labels?.[0]?.textContent || '';
        legend.textContent=nativeLabel.trim();group.append(legend);
        const options=make('div','lisa-sock__options');const inputs=[];
        for (const value of values) {
          const label=make('label','lisa-sock__option'), input=make('input');
          input.type='radio';input.name=`${key}-option-${i}`;input.value=value;
          label.append(input,make('span','',value));options.append(label);inputs.push(input);
        }
        group.append(options);groups.push({group,inputs,index:i});
      }
      const note=make('p','lisa-beanie__note');note.setAttribute('aria-live','polite');
      this.prepend(packs,...groups.map(g=>g.group),note);native.hidden=true;this.ready=true;
      const counterpart=(v,bulk)=>variants.find(t=>isBulk(t)===bulk && t.options.every((o,i)=>i===packIndex || o===v.options[i]));
      const choose=v=>{if(!v)return;selects.forEach((s,i)=>s.value=v.options[i]);selects[0].dispatchEvent(new Event('change',{bubbles:true}));};
      const sync=()=>{
        const v=selected();if(!v)return;
        for(const c of controls){const t=counterpart(v,c.bulk);c.input.checked=isBulk(v)===c.bulk;c.input.disabled=!t?.available;c.price.textContent=t?money(t.price):'';c.detail.textContent=t?.available?`${money(t.price/(c.bulk?12:1))} ${labels.per_dozen}`:labels.sold_out;}
        for(const g of groups)for(const input of g.inputs){input.checked=input.value===v.options[g.index];input.disabled=!variants.some(t=>isBulk(t)===isBulk(v)&&t.options[g.index]===input.value&&t.available);}
        note.textContent=(isBulk(v)?labels.bulk_note:labels.dozen_note)+' '+labels.wholesale_note;
        if(v.options.some(o=>/assort|surtid/i.test(o)))note.textContent+=' '+labels.assorted_note;
        note.textContent+=' '+labels.photo_note;
      };
      packs.addEventListener('change',e=>choose(counterpart(selected(),e.target.value==='bulk')));
      for(const g of groups)g.group.addEventListener('change',e=>{
        const v=selected(),same=variants.filter(t=>isBulk(t)===isBulk(v)&&t.options[g.index]===e.target.value&&t.available);
        choose(same.find(t=>t.options.every((o,i)=>i===g.index||i===packIndex||o===v.options[i]))||same[0]);
      });
      selects.forEach(s=>s.addEventListener('change',sync));sync();
    }
  });
}
